import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';

/**
 * Generated class for the AnalyticsReportListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-analytics-report-list',
  templateUrl: 'analytics-report-list.html',
})
export class AnalyticsReportListPage {

  @Input() list: any;
  @Input() quantity: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService) {
  }

  openReport(element) {
    if (element.access) {
    this.navCtrl.push(element.push);
    }else {
      this.navCtrl.push(AddonsTriggerVersionProPage);

    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/analytics/components/analytics-report-list/analytics-report-list.ts